import React from "react";
import { BrowserRouter, Switch, NavLink, Route, Redirect, useRouteMatch } from "react-router-dom";
import Context, { useTranslation } from "../../context";
import Layout from "../../Layout";
import MainTabs from "../../components/MainTabs";
import PageList from "./PageList";
import SpaceList from "./SpaceList";
import "../../common/index.less";
import "./index.less";

export default function () {
  const lang = useTranslation();
  const { path, url } = useRouteMatch();
  return (
    <div className="joyspace-collection-wrap">
      <Layout>
        <div className="joyspace-header">
          <Layout.Breadcrumbs text={lang("collections.title")} />
          <div
            style={{
              height: 40,
              display: "flex",
              alignItems: "center",
              marginRight: 10
            }}
          />
        </div>
        <MainTabs>
          <NavLink
            clstag="pageclick|keycount|focus_joyspace_01_1615797631505|20"
            to={`${url}/document`}
          >
            {lang("common.doc")}
          </NavLink>
          <NavLink
            clstag="pageclick|keycount|focus_joyspace_01_1615797631505|21"
            to={`${url}/space`}
          >
            {lang("common.space")}
          </NavLink>
        </MainTabs>
        <Switch>
          <Route exact path={path} component={() => <Redirect to={`${path}/document`} />} />
          <Route path={`${path}/document`} component={PageList} />
          <Route path={`${path}/space`} component={SpaceList} />
          <Redirect to={`${path}/document`} />
        </Switch>
      </Layout>
    </div>
  );
}
